export default (state= false, action: { type: string, payload: boolean }) => {
  switch (action.type) {
      case "SEARCH_TERM_LOADING":
        return action.payload;
    default:
      return state;
  }
}
